export default __webpack_public_path__ + "static/radial-icon-map-configuration-404c7cd85f9c2d78020408d3b9142d27.svg";